import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Container, Form, FloatingLabel, Button, Alert, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LanguageProvider } from '../../core/language-provider';
import { LoginManager } from '../../core/login-manager';
import { settings } from '../../config/settings';
import { toast } from 'react-toastify';

export default function Login() {
    const navigate = useNavigate();
    const location = useLocation();
    // pagina da cui si e' stati rimandati alla login: ci si torna dopo l'accesso
    const destinazione = location.state?.from || '/';
    const [username, setUserName] = useState('');
    const [password, setPassword] = useState('');
    // la password si puo' rileggere prima di mandarla: si sbaglia a digitarla
    // piu' spesso di quanto qualcuno stia guardando lo schermo
    const [mostraPassword, setMostraPassword] = useState(false);
    const [errors, setErrors] = useState('');
    const [accesso, setAccesso] = useState(false);

    async function handleSubmit(e) {
        e.preventDefault();
        if (accesso) return;
        setErrors('');
        setAccesso(true);
        try {
            const response = await LoginManager.login(username, password);
            if (response.success === 1 && response.status === 200) {
                const name = `${response.body.name} ${response.body.surname}`;
                navigate(destinazione, { replace: true });
                toast.success('Benvenuto ' + name + '!', { theme: 'colored' });
                return;
            }
            // l'errore sta nel riquadro sopra il bottone e ci resta: il toast
            // diceva la stessa cosa una seconda volta e spariva da solo
            setErrors(response?.message || LanguageProvider.get('errors.insert'));
        }
        catch (err) {
            setErrors('Impossibile contattare il server. Riprova.');
        }
        finally {
            setAccesso(false);
        }
    }


    return (
        <Container
            fluid
            id="login-container"
            className="px-3"
        >
            <Row className="login-layout gx-5">
                <Col lg={6} className="login-hero mb-5 mb-lg-0">
                    <div className="hero-copy">
                        <p className="hero-eyebrow text-uppercase d-flex align-items-center gap-2 mb-3">
                            <img className="lv-brandmark" src={`${process.env.PUBLIC_URL}/favicon.svg`} alt="" />
                            {settings.brand.name}
                        </p>
                        <h1 className="hero-title">
                            La sala living, prenotata in un minuto.
                        </h1>
                    </div>
                </Col>

                <Col lg={6}>
                    <div className="login-card">
                        <Form onSubmit={handleSubmit}>
                            <div className="text-start mb-4">
                                <p className="text-muted mb-1 small">Bentornato!</p>
                                <h3 className="fw-bold">{LanguageProvider.get('login.title')}</h3>
                                <p className="text-muted mb-0">
                                    Accedi per prenotare la sala living e gestire le tue richieste.
                                </p>
                            </div>

                            <FloatingLabel label="Email" className="mb-3">
                                <Form.Control
                                    type="email"
                                    placeholder="name@example.com"
                                    autoComplete="username"
                                    value={username}
                                    onChange={e => setUserName(e.target.value)}
                                    required
                                />
                            </FloatingLabel>

                            <FloatingLabel label={LanguageProvider.get('login.password')} className="mb-2">
                                <Form.Control
                                    type={mostraPassword ? 'text' : 'password'}
                                    className="login-password-input"
                                    placeholder="Password"
                                    autoComplete="current-password"
                                    value={password}
                                    onChange={e => setPassword(e.target.value)}
                                    required
                                />
                                <button
                                    type="button"
                                    className="login-password-toggle"
                                    onClick={() => setMostraPassword(v => !v)}
                                    aria-label={mostraPassword ? 'Nascondi la password' : 'Mostra la password'}
                                    aria-pressed={mostraPassword}
                                >
                                    <FontAwesomeIcon icon={['fas', mostraPassword ? 'eye-slash' : 'eye']} />
                                </button>
                            </FloatingLabel>

                            {/* rimasto solo, il link si tiene il suo lato della riga */}
                            <div className="text-end mb-3">
                                <Link to="/recover" className="text-decoration-none">
                                    Password dimenticata?
                                </Link>
                            </div>

                            {errors && (
                                <Alert variant="danger" className="py-2" role="alert">
                                    {errors}
                                </Alert>
                            )}

                            <Button
                                variant="primary"
                                type="submit"
                                className="w-100 mb-4"
                                disabled={accesso}
                            >
                                {accesso ? 'Accesso in corso…' : LanguageProvider.get('login.login')}
                            </Button>

                            {/* gli account li crea l'amministratore: nessuna registrazione */}
                            <p className="text-center text-muted mb-0">
                                Non hai un account? Chiedilo all'amministratore del condominio.
                            </p>
                        </Form>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}
